// <head> metadata for SolutionsCloudModernizationPage (https://www.dbos.dev/solutions/cloud-modernization).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'Cloud Modernization Platform',
    },
    {
      name: 'description',
      content:
        'DBOS radically simplifies cloud modernization by removing the complexity, cost, and security risks of the traditional cloud-native stack.  Based on 3 years of MIT-Stanford research.',
    },
    {
      property: 'og:title',
      content: 'Cloud Modernization Platform',
    },
    {
      property: 'og:description',
      content:
        'DBOS radically simplifies cloud modernization by removing the complexity, cost, and security risks of the traditional cloud-native stack.  Based on 3 years of MIT-Stanford research.',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/676384522fb637ef0af2b1d5_DBOS-Cloud-Modernization.jpg',
    },
    {
      name: 'twitter:title',
      content: 'Cloud Modernization Platform',
    },
    {
      name: 'twitter:description',
      content:
        'DBOS radically simplifies cloud modernization by removing the complexity, cost, and security risks of the traditional cloud-native stack.  Based on 3 years of MIT-Stanford research.',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/676384522fb637ef0af2b1d5_DBOS-Cloud-Modernization.jpg',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/solutions/cloud-modernization',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
